/** Justin — internal staff IP for admin analytics filtering */
export const JUSTIN_IP = '134.231.66.254';

/** Jeff — internal staff IP for admin analytics filtering */
export const JEFF_IP = '24.14.235.211';

/** Fixed staff IPs shown in admin IP reports (normalized keys). */
export const STAFF_IPS = [JUSTIN_IP, JEFF_IP] as const;

export function normalizeIpForCompare(ip: string): string {
  let s = ip.trim();
  const lower = s.toLowerCase();
  if (lower.startsWith('::ffff:')) {
    s = s.slice('::ffff:'.length);
  }
  return s.trim();
}

/**
 * IPs to hide when "Exclude Justin and Jeff" is on: staff plus optional viewer IP
 * (when known and not the literal "unknown").
 */
export function buildExclusionSet(viewerIp: string | null | undefined): Set<string> {
  const set = new Set<string>();
  for (const ip of STAFF_IPS) {
    set.add(normalizeIpForCompare(ip));
  }
  if (viewerIp == null || viewerIp === '') {
    return set;
  }
  const n = normalizeIpForCompare(viewerIp);
  if (n === '' || n.toLowerCase() === 'unknown') {
    return set;
  }
  set.add(n);
  return set;
}

export function isExcludedFromAnalytics(
  ip: string | undefined | null,
  exclusionSet: Set<string>
): boolean {
  if (ip == null || ip === '') {
    return false;
  }
  return exclusionSet.has(normalizeIpForCompare(ip));
}
